export const isValidMalaysianPhone = (phone: string): boolean => {
  // Loose validation: +601x or 01x followed by 8-9 digits
  const regex = /^(\+?60|0)1[0-9]{8,9}$/
  return regex.test(phone.replace(/[-\s]/g, ''))
}

export const validateFile = (file: File): string | null => {
  const MAX_SIZE_MB = 8
  const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic']

  if (!ALLOWED_TYPES.includes(file.type)) {
    return 'Only JPG, PNG, WebP, and HEIC images are allowed.'
  }

  if (file.size > MAX_SIZE_MB * 1024 * 1024) {
    return `File size must be less than ${MAX_SIZE_MB}MB.`
  }

  return null
}
